import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

const base_url = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class EmployeeHttpService {
  constructor(private httpClient: HttpClient) {}

  public fetchAll(): Observable<any> {
    return this.httpClient.get(`${base_url}api/employees`);
  }

  public fetchById(id): Observable<any> {
    return this.httpClient.get(`${base_url}api/employees/${id}`);
  }

  public add(data): Observable<any> {
    return this.httpClient.post(`${base_url}api/employees`, data);
  }

  public drag(data): Observable<any> {
    return this.httpClient.post(`${base_url}api/employees/update-weight`, data);
  }

  public update(data, id): Observable<any> {
    return this.httpClient.post(`${base_url}api/employees/${id}`, data);
  }

  public remove(id): Observable<any> {
    return this.httpClient.delete(`${base_url}api/employees/${id}`);
  }
}
